export default "__VITE_ASSET__6cfd467d__"